export const MONGO_DB_EMBED_CHART_SDK_BASE_URL = 'https://charts.mongodb.com/charts-prod-frdityz'
export const MONGO_DB_EMBED_CHART_SDK_DASHBOARD_ID = '678f897b-d9e0-4fab-8698-761fc1133233'
